export default __webpack_public_path__ + "static/BWDisrupt-50e7277b8429a54a910b7ab9630d7beb.png";